window.addEventListener('DOMContentLoaded', () => {
  const attributionPopup = document.querySelector('.attributionPopup');
  const attributionButton = document.querySelector('.single-page .attribution');

  if (!attributionPopup) {
    return;
  }

  const attributionClose = attributionPopup.querySelector('.attrClose');
  const attributionContent = attributionPopup.querySelector('.dialog');
  const attributionCopyLink = attributionPopup.querySelector('.attrCopyLink');
  const attributionLink = attributionPopup?.querySelector('.attrLink pre');

  const popupVisibleClass = 'attributionPopup--visible';

  attributionButton?.addEventListener('click', () => {
    attributionPopup?.classList.add(popupVisibleClass);
  });

  const closePopup = () => {
    attributionPopup?.classList.remove(popupVisibleClass);
  };

  attributionPopup?.addEventListener('click', closePopup);
  attributionClose?.addEventListener('click', closePopup);
  attributionContent?.addEventListener('click', event => {
    event.stopPropagation();
  });

  const copyLink = () => {
    const emailLink = attributionLink.textContent;
    if (emailLink) {
      navigator.clipboard.writeText(emailLink).then(() => {
        attributionCopyLink.textContent = 'Copied!';
      });
    }
  };

  attributionCopyLink?.addEventListener('click', () => {
    copyLink();
  });
});
